import React, { useRef, useState } from 'react';
// Data
import { faqsArray } from '../../utils/data/FaqData';

function FaqComponent() {
  const [openIndex, setOpenIndex] = useState(null);
  const faqRef = useRef(null);

  const toggleFaq = (index) => setOpenIndex(openIndex === index ? null : index);

  // 4 on-brand neon glow styles (cycles)
  const glowStyles = [
    {
      border: 'border-fuchsia-400/80',
      ring: 'focus-visible:ring-fuchsia-400',
      shadow: 'shadow-[inset_0_0_30px_rgba(232,121,249,0.25),0_0_40px_rgba(232,121,249,0.15)]',
    },
    {
      border: 'border-violet-400/80',
      ring: 'focus-visible:ring-violet-400',
      shadow: 'shadow-[inset_0_0_30px_rgba(167,139,250,0.25),0_0_40px_rgba(167,139,250,0.15)]',
    },
    {
      border: 'border-cyan-400/80',
      ring: 'focus-visible:ring-cyan-400',
      shadow: 'shadow-[inset_0_0_30px_rgba(34,211,238,0.25),0_0_40px_rgba(34,211,238,0.15)]',
    },
    {
      border: 'border-amber-400/80',
      ring: 'focus-visible:ring-amber-400',
      shadow: 'shadow-[inset_0_0_30px_rgba(251,191,36,0.25),0_0_40px_rgba(251,191,36,0.15)]',
    },
  ];

  return (
    <section className="grid gap-10 md:gap-14 lg:container lg:mx-auto" ref={faqRef} aria-label="FAQ list">
      {/* Lead copy (matches other pages’ tone) */}
      <div className="grid gap-6 text-center w-fit mx-auto">
        <h2 className="neon_text_duo_magenta_violet text-2xl font-semibold md:text-3xl w-fit mx-auto">
          Read Before You Kneel
        </h2>
        <div className="neon_line" />
        <p className="mx-auto max-w-[65ch] text-base leading-relaxed md:text-lg">
          Screening is required. Etiquette is expected. Tribute is for time and craft. If your question is here,
          don’t ask it twice.
        </p>
      </div>

      {/* Questions */}
      <div className="grid gap-4 md:gap-6 max-w-2xl mx-auto">
        {faqsArray.map((faq, index) => {
          const isOpen = openIndex === index;
          const g = glowStyles[index % glowStyles.length];
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          return (
            <article
              key={index}
              className={['grid rounded-2xl border bg-black/30 p-4 md:p-6', g.border, g.shadow].join(' ')}
            >
              <h3>
                <button
                  id={buttonId}
                  aria-controls={panelId}
                  aria-expanded={isOpen}
                  onClick={() => toggleFaq(index)}
                  className={[
                    'grid w-full grid-cols-[1fr_auto] items-center gap-3 text-left',
                    'font-semibold md:text-lg focus:outline-none focus-visible:ring-2',
                    g.ring,
                  ].join(' ')}
                >
                  <span>{faq.question}</span>
                  <span className="text-colour7 text-xl">{isOpen ? '−' : '+'}</span>
                </button>
              </h3>

              <div
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
                className={`grid transition-[grid-template-rows,opacity] duration-300 ${
                  isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-80'
                }`}
              >
                <div className="overflow-hidden">
                  <p
                    className="pt-3 text-sm leading-relaxed text-colour1/90 md:text-base"
                    // You already store HTML in answers
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  />
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FaqComponent;